module.exports = __webpack_public_path__ + "static/media/HostelWeb.9242f619.webp";